import Tabby from 'tabbyjs';

export default class TabManager {
  constructor() {
    this.tabSelectors = document.querySelectorAll('[data-tabs]');
    this.tabsInstances = {}; // キーをdata-tabsの値、値をTabbyのインスタンスとして格納
    this.initializeTabs();
    this.toggleTabsByAnchor();
  }

  initializeTabs() {
    this.tabSelectors.forEach((tabsElement) => {
      let key = tabsElement.getAttribute('data-tabs');
      this.tabsInstances[key] = new Tabby(`[data-tabs="${key}"]`);
    });
  }

  toggleTabs(sel) {
    for (let key in this.tabsInstances) {
      let currentTab = this.tabsInstances[key];
      document.querySelectorAll(sel).forEach(tab => currentTab.toggle(tab));
    }
  }

  toggleTabsByAnchor() {
    document.querySelectorAll('.p-recruit-our-job__tab-content-links a[href^="#"]').forEach((anchor) => {
      anchor.addEventListener('click', (e) => {
        e.preventDefault();
        let target = document.querySelector(anchor.getAttribute('href'));
        let href = anchor.getAttribute('href');
        if (target) {
          let currentTab = this.tabsInstances['jobs'];
          currentTab.toggle(href);

          return false;
        }
      });
    });
  }
}

